<template>
  <b-row align-h="between" align-v="end" class="the-detail__tags">
    <div class="col">
      <tag-list
        :entity-id="id"
        :entity-tags="tags"
        entity-type="site"
        @updatedTags="localSaveTags"
      />
    </div>
  </b-row>
</template>

<script>

import { mapState } from 'vuex'
import TagList from '@/components/Tags/TagList.vue'

export default {
  name: 'SiteDetailTags',

  components: {
    TagList
  },

  computed: {
    ...mapState('site', [
      'siteDetail',
      'showDetailPage'
    ]),

    show () {
      if (typeof this.siteDetail !== 'undefined' && typeof this.siteDetail.data.tags !== 'undefined') {
        return true
      }

      return false
    },

    id () {
      if (typeof this.siteDetail.id === 'undefined') {
        return 0
      }

      return this.siteDetail.id
    },

    tags () {
      if (typeof this.siteDetail.data.tags === 'undefined') {
        return []
      }

      return this.siteDetail.data.tags
    }

  },

  methods: {
    localSaveTags (tags) {
      this.data.tags = tags
    }
  }
}
</script>
